import { render, staticRenderFns } from "./ShowReciept.vue?vue&type=template&id=5c59a2f2&scoped=true&"
import script from "./ShowReciept.vue?vue&type=script&lang=js&"
export * from "./ShowReciept.vue?vue&type=script&lang=js&"
import style0 from "./ShowReciept.vue?vue&type=style&index=0&id=5c59a2f2&lang=scss&scoped=true&"
import style1 from "./ShowReciept.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c59a2f2",
  null
  
)

export default component.exports